import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, debounceTime } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { RequireMatch, Session, LocationsService, Entity } from '../../../core';
import { entityTypes } from '../../../configuration/shared/data/add-form';
import { DataTableService } from '../data-table/data-table.service';

/* interface Entity {
  entityType: string;
  entityCode: string;
  entityName: string;
} */

@Component({
  standalone: false,
  selector: 'app-autocomplete-entity',
  templateUrl: './autocomplete-entity.component.html',
  styleUrls: ['./autocomplete-entity.component.sass']
})
export class AutocompleteEntityComponent implements OnInit, OnChanges {
  @Input() local: boolean; // si la información se guardará en local storage
  @Input() disabled: boolean; // deshabilita la opcion de la tienda
  @Input() type: string;
  @Input() entity: any;
  @Output() entitySelect = new EventEmitter<any>();
  @Output() typeEntitySelect = new EventEmitter<any>();
  @Input() listEntity: Entity[] = [];
  @Input() entityTypeList: Object[];
  @Input() validateDisable: boolean = true;
  @Input() selectedEntityType: string;
  @Input() selectedEntityCode: string;
  entityType = new FormControl();
  entityCode = new FormControl(null, [RequireMatch]);
  public entityList: Object[] = [];
  public listEntityAutocomplete: Observable<Entity[]>;
  // public listEntity: Entity[];
  private session: Session;
  private initializedWithInputs = false;

  constructor(
    private locationsService: LocationsService,
    public dataTableService: DataTableService
  ) {
    this.session = JSON.parse(localStorage.getItem(environment.sessionAuth));
  }

  ngOnChanges() {
    if (this.listEntity && this.listEntity.length) {
     this.entityCode.updateValueAndValidity({ emitEvent: true });
    } 

    if (this.entity) {
      this.validationInitial();
    }
    if (this.disabled) {
      this.entityCode.disable({ onlySelf: true, emitEvent: false });
    }
    if (this.disabled && !!this.listEntity) {
      this.entityCode.setValue('');
    }

    if ((this.selectedEntityType || this.selectedEntityCode) && this.listEntity) {
      this.initializeWithSelectedValues();
    }
  }

  ngOnInit() {
    this.entityList = this.entityTypeList? this.entityTypeList:[];
    this.entityList = this.entityTypeList? this.entityTypeList:entityTypes;
    this.entityType.valueChanges.subscribe(change => {
      this.entityCode.setValue('');
      this.entityCode.setValidators(RequireMatch);
      this.entityCode.updateValueAndValidity();
      this.typeEntitySelect.emit(change);
    });
    this.listEntityAutocomplete = this.entityCode.valueChanges.pipe(
      debounceTime(200),
      startWith(''),
      map(value => (typeof value === 'string' 
        ? this.locationsService._filterEntity(this.listEntity ?? [], value) 
        : [])),
      map(value => {
        this.addFormEntity();
        return value;
      })
    );
    this.validationInitial();
  }

  initializeWithSelectedValues() {
    if (this.selectedEntityType && !this.initializedWithInputs) {
      this.entityType.setValue(this.selectedEntityType);
      this.initializedWithInputs = true;
    }

    if (this.selectedEntityCode && this.listEntity && this.listEntity.length > 0) {
      const selectedEntity = this.listEntity.find(entity =>
        entity.entityCode === this.selectedEntityCode
      );

      if (selectedEntity) {
        this.entityCode.setValue({
          entityCode: selectedEntity.entityCode,
          entityName: selectedEntity.entityName,
          entityType: selectedEntity.entityType
        });
      }
    }
  }

  sessionLocal(change) {
    if (this.local) {
      if (this.session.table) {
        this.session.table.stock = { filter: change };
      } else {
        this.session.table = { stock: { filter: change } };
      }
      this.dataTableService.setStorage(this.session);
    }
  }

  displayEntity(entity?: any) {
    return entity ? entity.entityName : undefined;
  }

  addFormEntity() {
    const change = this.entityCode.value;
    if (typeof change === 'object' && change !== null) {
      this.sessionLocal(this.entityType.value);
    }
    this.entitySelect.emit(change);
  }

  validationInitial() {
    if (this.selectedEntityType || this.selectedEntityCode) {
      if (this.selectedEntityType) {
        this.entityType.setValue(this.selectedEntityType);
      }
      return;
    }

    if (this.local === true) {
      if (this.session.table && this.session.table.stock) {
        this.entityType.setValue(this.session.table.stock.filter);
      } else {
        this.entityType.setValue('TD');
      }
    } else {
      if (this.type && this.entity) {
        this.entityCode.setValue(this.entity);
        this.entityType.setValue(this.type);
      } else {
        this.entityCode.setValue('');
        this.entityType.setValue(this.type ? this.type : 'TD');
      }
    }
  }

  resetForm() {
    this.entityCode.setValue(null);
    this.entityCode.setValidators(RequireMatch);
    this.initializedWithInputs = false;
  }
}
